/* eslint-disable camelcase */
/* eslint-disable no-console */
/* eslint-disable import/prefer-default-export */
import $http from '@vue-util/http';
import { Cookie } from '@vue-util/cookie';
import { cookies } from 'config';
import { post } from '@utils/api';
import { asyncNavigation } from '@utils/navigation';

export class ExpressCheckoutService {
  _deviceFingerPrint = '';

  _myBagUrl = '/my/bag';

  _startCheckoutUrl = '/chkout/startcheckout';

  _headers = {
    'x-requested-with': 'XMLHttpRequest',
  };

  async checkout() {
    // @ts-ignore
    const { PersistentLoginUtil } = await import(/* webpackChunkName: "persistent-login", webpackPrefetch: true */ '@vue-util/persistentLogin');
    this._deviceFingerPrint = PersistentLoginUtil.generateFingerPrint();
    const {
      offerAppliedInExpressCheckout,
      expressCheckoutPromoCode,
      checkoutError,
      redirectUrl,
      p2pBag,
    } = await this._executeProceedToCheckout();

    if (offerAppliedInExpressCheckout) {
      Cookie.set(
        'PromoCodeOne',
        expressCheckoutPromoCode,
        'SMISCGCs',
      );
    }
    const is365Customer = (Cookie.get('Login365Customer', 'MISCGCs') === 'Y');
    const expiryExtension = is365Customer ? 31556952000 : 2592000000;
    const cookieExpiry = new Date().getTime() + expiryExtension;
    const expires = new Date(cookieExpiry);
    if (p2pBag !== undefined) {
      Cookie.set('p2p_bag', decodeURIComponent(p2pBag), 'MISCGCs', { expires });
    }
    if (checkoutError) {
      Cookie.set('checkoutError', decodeURIComponent(checkoutError));
    }

    try {
      await this.redirect(redirectUrl);
    } catch (e) {
      console.error(e);
      await asyncNavigation(this._myBagUrl);
    }
  }

  async _executeProceedToCheckout() {
    const url = this._getExpressCheckoutURL();
    const deviceFPHeaders = { 'X-Macys-DeviceFingerPrint': this._deviceFingerPrint };
    const headersWithFingerPrint = { ...deviceFPHeaders, ...this._headers };
    const response = await post(url, {}, { headers: headersWithFingerPrint });
    const { ResponseEntity: responseEntity } = response;

    const offerAppliedInExpressCheckout = responseEntity?.body?.meta?.bagAttributes?.offerAppliedInExpressCheckout;
    const expressCheckoutPromoCode = responseEntity?.body?.meta?.bagAttributes?.expressCheckoutPromoCode;
    const resCookies = responseEntity?.body?.cookies;
    const checkoutError = resCookies?.checkoutError;
    const p2pBag = resCookies?.p2p_bag;
    const redirectUrl = responseEntity?.headers?.Location?.[0];

    return {
      offerAppliedInExpressCheckout,
      expressCheckoutPromoCode,
      checkoutError,
      redirectUrl,
      p2pBag,
    };
  }

  /**
   * @param {string} url
   * @returns {Promise<string>} redirect url
   */
  async _fetchRedirect(url) {
    const deviceFPHeaders = { 'X-Macys-DeviceFingerPrint': this._deviceFingerPrint };
    const headersWithFingerPrint = { ...deviceFPHeaders, ...this._headers };
    const response = await $http.get(url, {
      headers: headersWithFingerPrint,
      timeout: 15000,
    });
    const redirect_url = response?.headers?.redirect_url;

    if (!redirect_url) {
      throw new Error('redirect_url header is missing from the response');
    }
    return redirect_url;
  }

  /**
   * @param {string} url
   */
  async redirect(url) {
    if (url?.startsWith(this._startCheckoutUrl)) {
      const params = new URLSearchParams(url.split('?')[1]);
      // Bust the browser disk-cache everytime /chkout/startcheckout is called.
      const ts = new Date().getTime();
      params.set('ts', ts.toString());
      params.set('deviceFingerPrint', this._deviceFingerPrint);
      const rawRedirectUrl = `${this._startCheckoutUrl}?${params.toString()}`;

      const redirectUrl = await this._fetchRedirect(rawRedirectUrl);

      await asyncNavigation(redirectUrl);
      return;
    }
    await asyncNavigation(url);
  }

  /**
   * Get express checkout url
   */
  _getExpressCheckoutURL() {
    const bagguid = Cookie.get(cookies.bagGuid);
    return `/xapi/bag/v1/${bagguid}/expressCheckout`;
  }
}
